import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useEvents } from '@/composables/events'
import { useGWAnalytics } from '@/plugins/analytics/index'
import { useGWAnalyticsBasePayload } from '../plugins/analytics/composables/analyticsBasePayload'
import { State } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutButton',
  setup(__props) {

const store = useStore<State>()
const isLoggedIn = computed(() => store.getters.isLoggedIn)
const router = useRouter()
const { track } = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()
const { t } = useI18n()
const { modalEventBus } = useEvents()

const logout = async () => {
	const user = store.state.user
	await store.dispatch('logout')
	track('logout', { ...payload.value, user })
	modalEventBus.emit('close', { type: 'menu' })
	router.push('/')
}

return (_ctx: any,_cache: any) => {
  return (isLoggedIn.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (logout()), ["prevent"]))
      }, _toDisplayString(_unref(t)('log_out')), 1))
    : _createCommentVNode("", true)
}
}

})